import {
  ErrorModalInfo,
  ErrorModal
} from '../models/interface/error-modal-interface';

export const INELIGIBILITY_MODAL: ErrorModalInfo = {
  modalHeader: 'Change Flight',
  modalDetails:
    'Basic Economy tickets are nonchangeable, but are cancelable for a charge. Any remaining value is issued as an eCredit which can be used to book a new flight.<br></br>You may easily cancel by selecting Need to Cancel?',
  primaryAction: {
    action: 'cancel',
    label: 'need to cancel?',
    link: '/cancel-trip'
  }
};

export const INELIGIBILITY_INFO: ErrorModal = {
  basicEconomy: {
    modalHeader: 'Change Flight',
    modalDetails:
      'Basic Economy tickets are nonchangeable, but are cancelable for a charge. Any remaining value is issued as an eCredit which can be used to book a new flight.<br></br>You may easily cancel by selecting Need to Cancel?',
    primaryAction: {
      action: 'cancel',
      label: 'need to cancel?',
      link: '/cancel-trip'
    }
  },
  generic: {
    modalHeader: 'Change Flight',
    modalDetails: 'You are not eligible to change this flight.',
    primaryAction: {
      action: 'close',
      label: 'continue',
      link: ''
    }
  },
  notSoldByTravelAgency: {
    modalHeader: 'Change Flight',
    modalDetails:
      'Reasons why we are unable to complete your flight changes online:<ul><li>You may have a Group or Convention booking</li><li>You may have requested an upgrade which requires a certificate/miles</li><li>Your ticket was issued by another airline</li><li>You may be traveling with an infant in arms</li><li>Your reservation may require manual handling</li></ul>',
    primaryAction: {
      action: 'close',
      label: 'ok',
      link: ''
    },
    alternateAction: {
      action: 'messageus',
      label: 'message us',
      link: '/us/en/need-help/overview#messageUs'
    }
  },
  soldByTravelAgency: {
    modalHeader: 'Change Flight',
    modalDetails:
      'Reasons why we are unable to complete your flight changes online:<ul><li>You may have a Group or Convention booking</li><li>Your ticket was issued by another airline</li><li>You may be traveling with an infant in arms</li><li>Your reservation may require manual handling</li></ul>For books made from a travel site or agency, please contact that appropriate third party to make any changes.',
    primaryAction: {
      action: 'close',
      label: 'continue',
      link: ''
    }
  },
  systemError: {
    modalHeader: 'System Error',
    modalDetails:
      "We're sorry, but this system is not available at this time. Please try again later. For additional assistance, please contact a Delta representative by selecting Message Us.",
    primaryAction: {
      action: 'close',
      label: 'ok',
      link: ''
    },
    alternateAction: {
      action: 'messageus',
      label: 'message us',
      link: '/us/en/need-help/overview#messageUs'
    }
  }
};
